import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EventImg from '../../data/mainImg/EventImg.jpg';


type Props = {}

    const webWidth = window.innerWidth;

const EventModal = (props: Props) => {

    const [open, setOpen] = React.useState(true);

      const handleClose = () => {
        setOpen(false);
      };

      
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    {
                        webWidth > 1300
                        ?
                        <img src={EventImg} width={'500px'} />
                        :
                        <img src={EventImg} width={'100%'} />
                    }
                </DialogContent>
                <DialogActions>
                <Button variant='outlined' onClick={handleClose} autoFocus>
                    닫기
                </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default EventModal